import React, { useState } from "react";
import { IoMdArrowDropdown } from "react-icons/io";

const CustomDropdown = ({ options, selected, onSelect }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (option) => {
    onSelect(option);
    setIsOpen(false);
  };

  return (
    <div className="relative inline-block text-left">
      <div
        className="flex items-center bg-white shadow-md justify-between cursor-pointer border-none rounded-md px-3 py-2"
        onClick={() => setIsOpen(!isOpen)}
      >
        <span>{selected}</span>
        <IoMdArrowDropdown size={20} />
      </div>

      {isOpen && (
        <div className="absolute right-0 mt-2 w-48 bg-white border-none rounded-md shadow-lg z-10">
          {options.map((option, index) => (
            <div
              key={index}
              className="cursor-pointer px-4 py-2 hover:bg-gray-100"
              onClick={() => handleSelect(option)}
            >
              {option}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CustomDropdown;
